import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS, Permission, PermissionEntitiesNames } from '../../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/')({
  validateSearch: zodValidator(withDefaults(schema.CONTENT_PERMISSIONS, defaultFilter)),
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      (!!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.CONTENT_PERMISSIONS }) ||
        !!context.userPermissions.hasAllowedPermission({
          path: PAGE_PATHS.CONTENT_PERMISSIONS,
          permission: Permission.UPDATE,
        })) &&
      !!context.userPermissions.hasAllowedPermissionToResource({
        resource: PermissionEntitiesNames.ACCOUNT,
        permission: Permission.UPDATE,
      });
    context.validatePermissions({ isAllowed, preload });
  },
});
